interface CustomToggleProps {
  isSelected: boolean;
  onValueChange: (value: boolean) => void;
  disabled?: boolean;
  size?: "sm" | "md";
}

export const CustomToggle = ({ 
  isSelected, 
  onValueChange, 
  disabled = false, 
  size = "sm" 
}: CustomToggleProps) => {
  const sizeClasses = {
    sm: {
      container: "h-5 w-9",
      thumb: "h-3 w-3",
      translate: isSelected ? "translate-x-4" : "translate-x-1"
    },
    md: {
      container: "h-6 w-11", 
      thumb: "h-4 w-4",
      translate: isSelected ? "translate-x-6" : "translate-x-1"
    }
  };

  const currentSize = sizeClasses[size];

  return (
    <button
      onClick={() => !disabled && onValueChange(!isSelected)}
      disabled={disabled}
      className={`relative inline-flex ${currentSize.container} items-center rounded-full transition-colors duration-200 focus:outline-hidden focus:ring-2 focus:ring-moss-primary focus:ring-offset-1 ${
        isSelected
          ? "bg-moss-primary"
          : "bg-gray-200"
      } ${disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer hover:bg-opacity-80"}`}
    >
      <span
        className={`inline-block ${currentSize.thumb} transform rounded-full bg-white shadow-sm transition-transform duration-200 ${currentSize.translate}`}
      />
    </button>
  );
};
